import Image from "next/image"
import Link from "next/link"

import clsx from "clsx"

export default function NavigationLogo({ className }: { className?: string }) {
  return (
    <Link
      href="/"
      id="main-logo"
      className={clsx(
        "flex items-center justify-start overflow-visible transition-opacity",
        className
      )}
    >
      <Image
        loading="eager"
        fetchPriority="high"
        src="/shared/logo-white.svg"
        alt="Dash0 Logo"
        width={105}
        height={20}
        unoptimized
      />
    </Link>
  )
}
